import { render, staticRenderFns } from "./CalmTable.vue?vue&type=template&id=08542fc6&"
import script from "./CalmTable.vue?vue&type=script&lang=js&"
export * from "./CalmTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports